import useAppState from "context/useAppState";

import ChatMessages from "./Messages";
import InlineSVG from "react-inlinesvg";
import { isNewFete } from "utils/fete";
import React, { useEffect, useState } from "react";
import allImgPaths from "assets/images";
import StackedBarChart from "components/common/charts/StackedBarChart";
import InsightBuddy from "components/insights/InsightBuddy";
import RfpVendorBoxModal from "components/rfp/RfpVendorBoxModal";
import Highlight from "components/rfp/Highlights";
import RfpDataTable from "components/rfp/RfpDataTable";
import RfpTextBox from "components/rfp/RfpTextBox";
import { TAG_LINES } from "utils/constant";
import RfpTabularBox from "components/rfp/RfpTabularBox";
import RfpCompare from "components/rfp/RfpCompare";

const ChatboxBody = () => {
    const { messageHistory } = useAppState("chatMessages");
    const { showInsight, showReviewSpace } = useAppState("eventData");

    const { selectedCardDetail } = useAppState("cardWrapper");
    const [tagLines, setTagLines] = useState<any>(TAG_LINES);
    const [selectedTagLine, setSelectedTagLine] = useState<any>(null)

    const src = './fetebuddy-chatbox-animation.svg';
    const height = "416px";
    const width = "540px";


    useEffect(() => {
        const selected = tagLines.find((tl: any) => tl.card.toLowerCase() == selectedCardDetail?.title?.toLowerCase())
        setSelectedTagLine(selected)
    }, [selectedCardDetail])

    return (
        <div className={`px-6 py-6 overflow-y-auto chat-box-height-toggle bg-white relative border-l border-r border-[#EAECF0] 
            ${showInsight ? 'insight-body' : ''} ${showReviewSpace ? 'review-space-body' : ''}`}>
            {/* Initial Fete Screen with Round shape */}
            {
                !isNewFete() && messageHistory.length === 0 && (
                    <div className="w-[480px] h-[336px] mx-auto items-center flex rounded-shape-bg-chatbox absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                        <div className="text-center">
                            {/* <img className="mx-auto mb-4" src={fetebuddyGradientIcon} alt="" /> */}
                            {/* {(InlineSVG as (props: any) => JSX.Element)({ src, height, width })} */}

                            {
                                !showInsight &&
                                <>
                                    {
                                        !selectedTagLine &&
                                        <>
                                            <p className="text-xl font-interbold text-[#ec14ff]">{selectedCardDetail?.title} Fete Buddy</p>
                                            <p className="text-base text-[#475467]">
                                                Fete theme unclear? No need to fear! Your Fete Buddy is always here.
                                                <b> Pick a command, or let's chat !!</b>
                                            </p>
                                        </>
                                    }
                                    {
                                        selectedTagLine &&
                                        <>
                                            <p className="text-xl font-interbold text-[#ec14ff]">{selectedTagLine?.card} - Fete Buddy</p>
                                            <p className="text-base text-[#475467]">
                                                {selectedTagLine?.content}
                                                <b>
                                                    {selectedTagLine?.chatText}
                                                </b>
                                            </p>
                                        </>
                                    }
                                </>
                            }
                        </div>
                    </div>
                )
            }

            {/* Chat Messages */}
            <ChatMessages />

            {/* Insights */}
            <InsightBuddy />

            {/* RFP */}
            {/* <Rfp /> */}
            <RfpVendorBoxModal />
            {/* <RfpCompare /> */}
            {/* <RfpDataTable />
            <Highlight />
            <RfpTextBox />
            <RfpTabularBox /> */}

            {/* <RfpTabularBox /> */}
            {/* <RfpDataTable /> */}
        </div>
    )
}

export default React.memo(ChatboxBody)